(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('lodash')) :
  typeof define === 'function' && define.amd ? define(['exports', 'lodash'], factory) :
  (global = global || self, factory(global['object-browser'] = {}, global._));
}(this, (function (exports, _) { 'use strict';

  _ = _ && Object.prototype.hasOwnProperty.call(_, 'default') ? _['default'] : _;

  function browser(o, path) {
    var configs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var exists = false;
    var combined = false;

    if (path !== '__self') {
      var parts = _.isArray(path) ? path : path.split('.');
      var first = parts.shift();

      if (o.hasOwnProperty(first)) {
        exists = true;
      }

      if (_.isPlainObject(o)) {
        o = o[first];
      } else if (_.isArray(o)) {
        if (!_.isNaN(+first)) {
          o = o[first];
        } else {
          combined = true;
          o = _.reduce(o, function (accum, o) {
            if (o.hasOwnProperty(first)) {
              accum.push(o[first]);
              exists = true;
            }

            return accum;
          }, []);

          if (configs.flatten) {
            o = _.flatten(o);
          }
        }
      } else {
        o = undefined;
      }

      if (parts.length && o) {
        return browser(o, parts, configs);
      }
    } else {
      exists = true;
    }

    if (configs.hasOwnProperty('flatten')) {
      delete configs.flatten;
    }

    if (!_.keys(configs).length) {
      return o;
    }

    var results = {
      value: o
    };

    if (configs.hasOwnProperty('exists')) {
      Object.assign(results, {
        exists: exists
      });
    }

    if (configs.hasOwnProperty('combined')) {
      Object.assign(results, {
        combined: combined
      });
    }

    return results;
  }

  exports.browser = browser;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
